export default __webpack_public_path__ + "static/media/category-clanek.a63a5a8b.jpg";